const GLOBALS = {
  PREFIXES: ["+99412", "+99450", "+99451", "+99455", "+99470", "+99477"],
  SELMENU: "new",
  azDataPickerLocale: {
    lang: {
      placeholder: "Tarix seçin",
      rangePlaceholder: ["Başlama tarixi", "Bitmə tarixi"],
      today: "Bugün",
      now: "İndi",
      backToToday: "Bugünə qayıt",
      ok: "Seç",
      clear: "Təmizlə",
      month: "Ay",
      year: "İl",
      timeSelect: "Vaxt seçin",
      dateSelect: "Tarix seçin",
      monthSelect: "Ay seçin",
      yearSelect: "İl seçin",
      decadeSelect: "Choose a decade",
      yearFormat: "YYYY",
      dateFormat: "M/D/YYYY",
      dayFormat: "D",
      dateTimeFormat: "M/D/YYYY HH:mm:ss",
      monthFormat: "MMMM",
      monthBeforeYear: true,
      previousMonth: "Əvvəlki ay",
      nextMonth: "Növbəti ay",
      previousYear: "Keçən il (Control + left)",
      nextYear: "Növbəti il (Control + right)",
      previousDecade: "Last decade",
      nextDecade: "Next decade",
      previousCentury: "Keçən əsr",
      nextCentury: "Növbəti əsr",
    },
    timePickerLocale: {
      placeholder: "Vaxt seçin",
    },
    dateFormat: "YYYY-MM-DD",
    dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
    weekFormat: "YYYY-wo",
    monthFormat: "YYYY-MM",
  },
};

export default GLOBALS;
